import {MessageLoader} from "./message.loader";
import {MessageSections} from "../../../pages/components/message/message";
import {AuthContentContainer, Content} from "../../styled";
import Login from "../../../pages/auth/login";
import {Navigate} from "react-router-dom";
import SignUp from "../../../pages/auth/sign-up";
import Recover from "../../../pages/auth/recover";
import ChangePassword from "../../../pages/auth/change-password";
import AuthStatus from "../../../pages/info/auth-status";
import React from "react";

export const LoginRoute = {
    path: 'login',
    Component: () => {
        const hasToken = localStorage.getItem("access_token");

        if (!hasToken) {
            return (
                <MessageLoader sectionName={MessageSections.LOGIN}>
                    <AuthContentContainer>
                        <Content>
                            <Login/>
                        </Content>
                    </AuthContentContainer>
                </MessageLoader>
            )
        } else {
            return <Navigate to={'../orders'}/>
        }
    }
};

export const RegisterRoute = {
    path: 'register',
    Component: () => {
        const hasToken = localStorage.getItem("access_token");

        if (!hasToken) {
            return (
                <MessageLoader sectionName={MessageSections.LOGIN}>
                    <AuthContentContainer>
                        <Content>
                            <SignUp/>
                        </Content>
                    </AuthContentContainer>
                </MessageLoader>
            )
        } else {
            return <Navigate to={'../orders'}/>
        }
    }
}

export const PasswordRecoverRoute = {
    path: 'recover',
    Component: () => {
        const hasToken = localStorage.getItem("access_token");

        if (!hasToken) {
            return (
                <MessageLoader sectionName={MessageSections.LOGIN}>
                    <AuthContentContainer>
                        <Content>
                            <Recover/>
                        </Content>
                    </AuthContentContainer>
                </MessageLoader>
            )
        } else {
            return <Navigate to={'../orders'}/>
        }
    }
}

export const ChangePasswordRoute = {
    path: 'change-password',
    Component: () => {
        const hasToken = localStorage.getItem("access_token");

        if (!hasToken) {
            return (
                <MessageLoader sectionName={MessageSections.LOGIN}>
                    <AuthContentContainer>
                        <Content>
                            <ChangePassword/>
                        </Content>
                    </AuthContentContainer>
                </MessageLoader>
            )
        } else {
            return <Navigate to={'../orders'}/>
        }
    }
}

export const AccountActivationRoute = {
    path: 'account-activation',
    Component: () => {
        return (
            <MessageLoader sectionName={MessageSections.LOGIN}>
                <AuthContentContainer>
                    <Content>
                        <AuthStatus authStatusTitle={'account_activation_required'}
                                    authStatusInfo={'account_activation_info'}/>
                    </Content>
                </AuthContentContainer>
            </MessageLoader>
        )
    }
}